module.exports = __webpack_public_path__ + "img/ti.c2426acf.png";